// @flow

import React from 'react';
import { message, Modal } from 'antd'
import { updateOrderItems, updateOrderCaveats } from '../../../HttpRequests/orders';
import { setEditable } from '../State/editable';
import { setSelectedOrderItemIds } from '../State/selectedOrderItemIds';
import fetchOrder from './fetchOrder';
import handleException from '../../../Core/Helpers/handleException';

export default () => async (dispatch: Function, getState: Function) => {

  try {

    const { order } = getState().screens.OrderView;

    const { id } = order;

    // Validate that all order items have a type
    const itemsWithoutType = [];
    order.order_groups.forEach((group, groupIndex) => {
      group.order_items.forEach((item, itemIndex) => {
        // Check if type is missing, null, undefined, or empty string
        // Note: 'none' is a valid placeholder value
        if (!item.type || item.type === '' || item.type === null || item.type === undefined) {
          itemsWithoutType.push({
            groupName: group.name || `Group ${groupIndex + 1}`,
            lineNumber: item.line_number || (itemIndex + 1)
          });
        }
      });
    });

    if (itemsWithoutType.length > 0) {
      Modal.warning({
        title: 'Cannot Save Order',
        content: (
          <div>
            <p>The following items are missing a type:</p>
            {itemsWithoutType.map((item, index) => (
              <div key={index}>
                {`• Line ${item.lineNumber} in "${item.groupName}"`}
              </div>
            ))}
            <p style={{ marginTop: 12 }}>Please select a type for each item before saving.</p>
          </div>
        ),
        width: 500
      });
      return;
    }

    // Convert 'none' back to null before sending to backend
    const sanitizedOrderGroups = order.order_groups.map(group => ({
      ...group,
      order_items: group.order_items.map(item => ({
        ...item,
        type: item.type === 'none' ? null : item.type
      }))
    }));

    await updateOrderItems({ id, data: sanitizedOrderGroups });

    await updateOrderCaveats({ id, data: order.order_caveats });

    dispatch(setEditable(false));

    dispatch(setSelectedOrderItemIds([]));

    message.success("Order Updated");

    await dispatch(fetchOrder());

  } catch (error) {

    handleException(error);

    throw error;

  }

}
